import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { useLocation } from 'react-router-dom';
import { ORIGIN, PUBLIC_ROUTES } from '../content/publicRoutes.generated';
import { SEO_CONFIG } from '../config';

const routeByPath = Object.fromEntries(PUBLIC_ROUTES.map((route) => [route.path, route]));

export default function RouteMetadata() {
  const { pathname } = useLocation();
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  const route = routeByPath[normalizedPath];
  if (!route) return null;

  const canonical = normalizedPath === '/' ? ORIGIN : `${ORIGIN}${normalizedPath}`;
  return (
    <Helmet>
      <title>{route.title}</title>
      <meta name="description" content={route.description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={route.title} />
      <meta property="og:description" content={route.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={SEO_CONFIG.OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={route.title} />
      <meta name="twitter:description" content={route.description} />
      <meta name="twitter:image" content={SEO_CONFIG.OG_IMAGE} />
    </Helmet>
  );
}
